import React, { FC } from 'react';
import { Button, Empty, Modal } from 'antd';
import { ComplianceEvaluationResults } from './ComplianceEvaluationResults';
import { ComplianceRequest, ComplianceRequestInstance } from '../../types/ComplianceTypes';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

interface ComplianceEvaluationModalProps {
	visible: boolean;
	// The instance whose stored checklistEvaluation is shown. Both the evaluation
	// and the checklist it was measured against are persisted on the instance and
	// its request, so there is nothing to fetch.
	instance: ComplianceRequestInstance;
	// The request the instance belongs to, when the caller already holds it. The
	// buyer reviewer does; the supplier list reads it off the hydrated instance.
	// Either way the items come from the same stored checklistExtraction.
	complianceRequest?: ComplianceRequest;
	onCancel: () => void;
}

// Reopens the AI check a supplier already saw when they linked the document.
export const ComplianceEvaluationModal: FC<ComplianceEvaluationModalProps> = ({
	visible,
	instance,
	complianceRequest,
	onCancel,
}): React.ReactElement => {
	const evaluation = nullSafeGet('checklistEvaluation', instance);
	const checklistItems = complianceRequest
		? nullSafeGetOrElse('checklistExtraction.items', complianceRequest, [])
		: nullSafeGetOrElse('complianceRequest.checklistExtraction.items', instance, []);
	const fileName = nullSafeGet('linkedComplianceDocument.fileName', instance);
	const footer = (
		<Button type="primary" onClick={onCancel}>
			DONE
		</Button>
	);
	return (
		<Modal
			visible={visible}
			title={`Document check: ${
				nullSafeGet('name', complianceRequest) ||
				nullSafeGetOrElse('complianceRequest.name', instance, 'Compliance request')
			}`}
			onCancel={onCancel}
			footer={footer}
			width={900}
			bodyStyle={{ maxHeight: '60vh', overflowY: 'auto' }}
		>
			{evaluation ? (
				<ComplianceEvaluationResults
					evaluation={evaluation}
					checklistItems={checklistItems}
					fileName={fileName}
				/>
			) : (
				<Empty description="This document has not been checked against the client's requirements." />
			)}
		</Modal>
	);
};
